export default __webpack_public_path__ + "static/goods-2-674433d2751947d0b28d62f7bdb993bb.png";